import { render } from "./MessageTemplate.vue?vue&type=template&id=90d1d3e6&scoped=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=js"
export * from "./MessageTemplate.vue?vue&type=script&lang=js"

import "./MessageTemplate.vue?vue&type=style&index=0&id=90d1d3e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d1d3e6"]])

export default __exports__